import * as Yup from 'yup';
import { weekRatesValidation } from '../../../../helpers/commonValidators';

export const Validator = () =>
  Yup.object().shape(weekRatesValidation());
